import { CURRENT_STATUS_FIELD } from '@shared/Tickets/utils';
import { createFileRoute } from '@tanstack/react-router';
import { entityProjectionNames } from '@utils/entityProjectionNames';
import { ACTIONS_MAP } from '@utils/entityViewConfig';
import { CodeOwner } from '@utils/router.utils';
import { getIsManualOverrideEnabled } from '@views/ModelManagement/hooks';
import { Permission, PermissionAppName, PermissionEntitiesNames } from '../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities')({
  staticData: {
    owner: CodeOwner.Uvm,
  },
  beforeLoad: ({ context, preload }) => {
    context.validateAppPermission('VULNERABILITIES', preload);
    return {
      shouldAllowAction: (projectionName: string, action: string) => {
        const isExceptionAction = action === ACTIONS_MAP.EXCEPTIONS_SECTION || action === ACTIONS_MAP.EXCEPTIONS_FORM;
        if (isExceptionAction) {
          return projectionName !== entityProjectionNames.IdentityFinding;
        }
        return true;
      },
      canManageExceptions: (hasAllowedPermissionToResource: any, fieldRegulations: any) =>
        hasAllowedPermissionToResource({
          category: PermissionAppName.VULNERABILITIES,
          resource: PermissionEntitiesNames.EXCEPTION,
          permission: Permission.AUDIT,
        }) && getIsManualOverrideEnabled(CURRENT_STATUS_FIELD, entityProjectionNames.Exception, fieldRegulations),
    };
  },
});
